import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { CurrentUserModule } from '®shared/current-user';
import { ReadingListModule } from '®shared/reading-list/models';
import { RedirectionModule } from '®shared/redirection';

import { ListResolverStoreModule } from '../resolver-store';

import { CanActivateDraftListView } from './can-activate-draft-list-view.service';
import { CanActivateListEdit } from './can-activate-list-edit.service';
import { CanActivateListView } from './can-activate-list-view.service';
import { CanActivatePublishedListView } from './can-activate-published-list-view.service';
import { CanActivateViewListAsStudent } from './can-activate-view-list-as-student.service';
import { DraftListResolver } from './draft-list-resolver.service';
import { PublishedListResolver } from './published-list-resolver.service';

@NgModule({
  imports: [
    CommonModule,
    CurrentUserModule,
    ListResolverStoreModule,
    ReadingListModule,
    RedirectionModule,
    RouterModule,
  ],
  providers: [
    CanActivateDraftListView,
    CanActivateListEdit,
    CanActivateListView,
    CanActivatePublishedListView,
    CanActivateViewListAsStudent,
    DraftListResolver,
    PublishedListResolver,
  ],
})
export class CurrentListResolverModule {}
